var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 0.833008C2.74258 0.833008 0.916748 2.65884 0.916748 4.91634C0.916748 7.34884 3.49508 10.703 4.55675 11.9805C4.79008 12.2605 5.21592 12.2605 5.44925 11.9805C6.50508 10.703 9.08342 7.34884 9.08342 4.91634C9.08342 2.65884 7.25758 0.833008 5.00008 0.833008ZM5.00008 6.37467C4.19508 6.37467 3.54175 5.72134 3.54175 4.91634C3.54175 4.11134 4.19508 3.45801 5.00008 3.45801C5.80508 3.45801 6.45842 4.11134 6.45842 4.91634C6.45842 5.72134 5.80508 6.37467 5.00008 6.37467Z",
    fill: "#0368A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1d49389ce253804e081245ed00edda50.svg";
export { ForwardRef as ReactComponent };